export const PRICE_FORMATS = ['₸', '₸/мес', '₸/день', '₸/неделя', '₸/год'] as const
export type PriceFormat = typeof PRICE_FORMATS[number]
export const priceFormat = (value: unknown): PriceFormat =>
    PRICE_FORMATS.includes(value as PriceFormat) ? value as PriceFormat : '₸'
export const MAX_PRICE = 999_999_999

// Reject invalid edits as a whole: -150 and 15.50 must not become 150 and 1550.
export const normalizePrice = (value: string): string | null => {
  if (!/^[0-9 \u00a0\u202f]*$/.test(value)) return null
  const digits = value.replace(/[ \u00a0\u202f]/g, '').replace(/^0+(?=\d)/, '')
  return Number(digits) <= MAX_PRICE ? digits : null
}
export const formatPrice = (value: string): string => {
  const normalized = normalizePrice(value)
  return normalized === null ? value : normalized.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}

export const priceCaret = (formatted: string, digitsBefore: number): number => {
  if (!digitsBefore) return 0
  let count = 0
  for (let index = 0; index < formatted.length; index++) {
    if (/\d/.test(formatted[index]) && ++count === digitsBefore) return index + 1
  }
  return formatted.length
}
